import { render, staticRenderFns } from "./TaskListEditListDetails.vue?vue&type=template&id=4f74b80c&scoped=true"
import script from "./TaskListEditListDetails.vue?vue&type=script&lang=js"
export * from "./TaskListEditListDetails.vue?vue&type=script&lang=js"
import style0 from "./TaskListEditListDetails.vue?vue&type=style&index=0&id=4f74b80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74b80c",
  null
  
)

export default component.exports